import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LanguageProvider } from './contexts/LanguageContext';
// Import Lato font weights
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '../public/styles/main.css';

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
    // Register immediately, don't wait for load event
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .then((registration) => {
            console.log('Service Worker registered successfully:', registration.scope);

            const checkForUpdate = () => {
                registration.update().catch(() => {});
            };

            // Force update check on load and when the tab becomes visible again
            checkForUpdate();
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    checkForUpdate();
                }
            });

            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (newWorker) {
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            // New SW is ready; a normal reload is enough (hashed assets +
                            // network-first HTML). No hard refresh required.
                            console.log('New content available; reload the page to use it.');
                        }
                    });
                }
            });

            // Periodic update check (fallback if the tab stays open for a long time)
            setInterval(checkForUpdate, 60 * 60 * 1000);
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
}

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <BrowserRouter>
            <LanguageProvider>
                <App />
            </LanguageProvider>
        </BrowserRouter>
    );
} 